export const appConfig = {
    apiUrl: import.meta.env.VITE_API_URL as string,
    notesAppUrl: import.meta.env.VITE_NOTES_APP_URL as string,
    marketingSiteUrl: import.meta.env.VITE_MARKETING_SITE_URL as string,
    appEnv: import.meta.env.VITE_APP_ENV as string,
    userPoolId: import.meta.env.VITE_USER_POOL_ID as string,
    userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID as string,
};
